import { render, staticRenderFns } from "./JSnackbars.vue?vue&type=template&id=061078cc&scoped=true&"
import script from "./JSnackbars.vue?vue&type=script&lang=js&"
export * from "./JSnackbars.vue?vue&type=script&lang=js&"
import style0 from "./JSnackbars.vue?vue&type=style&index=0&id=061078cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061078cc",
  null
  
)

export default component.exports